import React from 'react';
const IconMiscLearn = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M1 9L12 3L23 9V17H21V10.09L12 15L1 9ZM5 17.18V13.18L12 17L19 13.18V17.18L12 21L5 17.18Z" fill="#666666"/>
</svg>
);
};
export default IconMiscLearn;